module.exports = __webpack_public_path__ + "assets/Cursor-Pointer.6da60698.svg";